import React from 'react';
import ShortInterestWidgetBuilder from './ShortInterestWidgetBuilder';
import ShortInterestWidgetRenderer from './ShortInterestWidgetRenderer';
import Preview from './Preview';
import type { WidgetDefinition } from '../../../registry';
import type { ShortInterestWidgetConfig } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowTrendDown } from '@fortawesome/free-solid-svg-icons';

export { default as ShortInterestWidgetBuilder } from './ShortInterestWidgetBuilder';
export { default as ShortInterestWidgetRenderer } from './ShortInterestWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'short_interest',
  meta: {
    label: 'Short Interest',
    icon: React.createElement(FontAwesomeIcon, { icon: faArrowTrendDown }),
    description: 'Short-interest history with FINRA positions, SEC shares outstanding, and FMP/INSYNC price context',
    isSystem: true,
    isCreatable: true,
    requiresAsset: true,
    dataFlow: 'display',
  },
  dataProvider: {
    widget: 'SHORT_INTEREST',
    // 26 bi-monthly settlements ≈ the full rolling year the consolidated
    // dataset covers (also FINRA's dispatch default since the limit fix),
    // so the 3M/6M/All range pills have real data behind them.
    params: [
      { key: 'short_interest_limit', label: 'Settlements', defaultValue: 26, unit: 'reports', type: 'number', placeholder: '26' },
    ],
  },
  defaultSize: { w: 8, h: 6, minW: 5, minH: 5 },
  defaultConfig: () => ({
    short_interest_provider: 'AUTO',
    price_provider: 'AUTO',
  } as ShortInterestWidgetConfig),
  Builder: ShortInterestWidgetBuilder,
  Renderer: ShortInterestWidgetRenderer,
  Preview,
};
